import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AllHomeBanner.css';

const AllHomeBanner = () => {
  const [category, setCategory] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/getBannerImages`);
        const data = response.data;

        if (data.status === 'ok') {
          setCategory(data.data);
        } else {
          setMessage(data.message);
        }
        setLoading(false);
      } catch (error) {
        setMessage('An error occurred: ' + error.message);
        setLoading(false);
      }
    };

    fetchCategory();
  }, []);

  if (loading) {
    return (
      <div className="banner-loading">
        <div className="loading-text">Loading banners...</div>
      </div>
    );
  }

  return (
    <div className="tradeindia-banner-sidebar">
      {message && <div className="banner-error">{message}</div>}
      {error && <div className="banner-error">{error}</div>}
      
      <div className="banner-list">
        {category.map((cat, index) => (
          <div key={index} className="banner-item">
            <div className="banner-card">
              {cat.image ? (
                <img 
                  src={`${process.env.REACT_APP_API_URL}/${cat.image.replace('\\', '/')}`} 
                  className="banner-image"  
                  alt={cat.name || `Banner ${index + 1}`}
                />
              ) : (
                <div className="banner-placeholder">
                  <i className="fas fa-image"></i>
                  <span>No Image</span>
                </div>
              )}
              {cat.name && (
                <div className="banner-overlay">
                  <span className="banner-title">{cat.name}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllHomeBanner;